import React, { useEffect } from "react"
import PropTypes from 'prop-types'
// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"
import Utils from '../Utility';

import { Container, Row, Col, CardBody, Card, Button } from "reactstrap"

// import images
import logo from "../../assets/images/logo-sm-dark.png";
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import { loginUser, apiError } from "../../store/actions";
import { toast } from "react-toastify";
import Toastify from '../../components/Toastify';

const LockScreen = (props) => {
  console.log('props on auth screen', props);
  const handleValidSubmit=async(e, v)=>{
    let data = JSON.parse(await localStorage.getItem("authUser"));
    // console.log('values on unlock', v);
    let body = {
      ...v,
      email: data?.email,
    }
    console.log('values on unlock', body);
    props.loginUser(body, props.history);
  }

  useEffect(()=>{
    if(props?.error){
      toast.error(props?.error);
      props?.apiError(null);
    }
  }, [props?.error]);
  

  return (
    <React.Fragment>
        <Toastify />
      {/* <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div> */}
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-login text-center">
                  <div className="bg-login-overlay"></div>
                  <div className="position-relative">
                    <h5 className="text-white font-size-20">Lock screen</h5>
                    <p className="text-white-50 mb-0">Enter your password to unlock the screen!</p>
                    <Link to="/" className="logo logo-admin mt-4">
                      <img src={logo} alt="" height="60" />
                    </Link>
                  </div>
                </div>
                <CardBody className="pt-5">

                  <div className="p-2">
                    <AvForm className="form-horizontal" onValidSubmit={(e, v)=>handleValidSubmit(e, v)}>
                      <div className="user-thumb text-center mb-4">
                        {/* <img src={avatar1}
                          className="rounded-circle img-thumbnail avatar-md" alt="thumbnail" /> */}
                        <h5 className="font-size-15 mt-3">{Utils.projectName}</h5>
                      </div>

                      <div className="mb-3">
                        <AvField
                          name="password"
                          label="Password"
                          type="password"
                          required
                          placeholder="Enter Password"
                        />
                      </div>

                      <div className="row mb-0">
                        <div className="col-12 text-end">
                          <Button
                            className="w-md waves-effect waves-light"
                            type="submit"
                            style={{backgroundColor:Utils.themeColor, border:'none'}}
                          >
                            Unlock
                            </Button>
                        </div>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>Not you ? return <Link to="/login" className="fw-medium text-primary"> Sign In
                    </Link> </p>
                <p>
                  © {new Date().getFullYear()} {Utils.projectName}. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Team Rajmith
                  </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

LockScreen.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
}

const mapStatetoProps = state => {
  const { error, loading } = state.Login
  return { error, loading }
}

export default withRouter(
  connect(mapStatetoProps, { loginUser, apiError })(LockScreen)
)